import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  PersonalizationEngineRequest,
  PersonalizationEngineResponse
} from './data-models/personalization-engine.interface';
import { PersonalizationEngineService } from './data-services/personalization-engine.service';

@Injectable({
  providedIn: 'root'
})
export class FlowRouterService {
  constructor(private engine: PersonalizationEngineService) {}

  getResponse = (
    campaignId: string
  ): Observable<PersonalizationEngineResponse> => {
    const request: PersonalizationEngineRequest = {
      userdata: {},
      requestparam: {
        campaignId: campaignId,
        format: 'json'
      }
    };
    return this.engine.getContent(request);
  };
}
